import { NameProperty } from '@edgebox/data-definition-kit';
import {
  EditMode,
  EntityContext,
  EntityForm,
  EntityFormRow,
  entityFormWithValidation,
  IEntityFormProps,
  IEntityFormState,
} from '../../../../../common';
import { AddSystemClientInput } from '../../PublisherClient';
import React, { PropsWithChildren, useMemo } from 'react';
import { FormField } from '@edgebox/react-components';

class AddClient {
  constructor(set?: AddClient) {
    if (set) {
      Object.assign(this, set);
    }
  }

  @NameProperty()
  name!: string;
}

interface AddClientFormProps extends IEntityFormProps<AddClient, AddClient>, PropsWithChildren {
  spaceId: string;
  onSave: (draft: AddSystemClientInput) => Promise<void>;
}
interface AddClientFormState extends IEntityFormState<AddClient> {}
const ClientFormWithValidation = entityFormWithValidation<AddClient, AddClient>(AddClient, AddClient);
export class AddClientInnerForm extends EntityForm<AddClient, AddClient, AddClientFormProps, AddClientFormState> {
  constructor(props: AddClientFormProps) {
    super(props, {
      edit: EditMode.Full,
    });
  }

  async load() {
    return {};
  }

  render() {
    return (
      <>
        <EntityContext.Provider value={this.entityContext}>
          <ClientFormWithValidation
            {...this.formProperties()}
            apiComponent={this}
            initialValues={this.props.entity}
            labels={'above'}
            onSubmit={async (entity) => {
              this.setState({
                extendProperties: [],
              });

              const draft: AddSystemClientInput = {
                spaceId: this.props.spaceId,
                ...entity,
              };

              await this.props.onSave(draft);
            }}
          >
            {({ values, setValue, errors }) => (
              <>
                <EntityFormRow<AddClient>
                  name={'name'}
                  label={'Name'}
                  edit={() => <FormField<AddClient> type={'text'} name={'name'} labelPlacement={'none'} noRow />}
                  view={values.name ? () => values.name : undefined}
                />

                {this.props.children}
              </>
            )}
          </ClientFormWithValidation>
        </EntityContext.Provider>
      </>
    );
  }
}
export function AddClientForm(props: Omit<AddClientFormProps, 'entity'>) {
  const draft = useMemo(() => {
    return new AddClient({
      name: '',
    });
  }, []);

  return <AddClientInnerForm {...props} entity={draft} />;
}
